import { CXRAY_ANALYSIS, ECG_ANALYSIS, XRAY_MANUAL } from 'navigation/CONSTANTS'
import { DiagnosticsListConfig } from '../types'

/**
 * Configurações das duas telas de listagem. Fonte única de verdade para
 * tipo, rota base e chave de sessionStorage — reutilizada pelas páginas
 * (Cxray/Ecg) e pela tela de detalhe (para voltar à lista correta).
 */
export const CXRAY_LIST_CONFIG: DiagnosticsListConfig = {
  examType: 'cxray',
  title: 'Análise de Raio-X',
  basePath: CXRAY_ANALYSIS,
  storageKey: 'lastCxrayFilters',
  manualHref: XRAY_MANUAL,
  manualTooltip: 'Manual de uso - Raio-X',
  icon: (
    <span
      style={{ color: 'var(--secondarySoft-button-color)' }}
      className='material-symbols-outlined'
    >
      radiology
    </span>
  )
}

export const ECG_LIST_CONFIG: DiagnosticsListConfig = {
  examType: 'ecg',
  title: 'Análise de ECG',
  basePath: ECG_ANALYSIS,
  storageKey: 'lastEcgFilters',
  icon: (
    <span
      style={{ color: 'var(--secondarySoft-button-color)' }}
      className='material-symbols-outlined'
    >
      ecg
    </span>
  )
}
